module.exports = __webpack_public_path__ + "img/default2.ed74595f.jpg";